<div class="openCatalog" [class.is-open]="isShowBlock" (mouseenter)="showBlock(true)" (mouseleave)="showBlock(false)">

  <button status="primary" nbButton i18n="@@Catalog" (click)="toggleBlock()">
    <tui-icon icon="list"/>
    Каталог
  </button>

  <div [hidden]="!isShowBlock" class="menuCatalog">
    <div class="menuCatalog__content">
      <div class="list-menu">
        <div class="tree-container">
          <mat-tree [dataSource]="dataSource" [levelAccessor]="getLevel" class="example-tree" #tree="matTree">
            <mat-tree-node *matTreeNodeDef="let node"
                           [isExpandable]="!node.lastLevel"
                           (expandedChange)="onExpandedChange(node, $event)">
              <li class="mat-tree-node" [class.catalog-active]="isActive(node)">

                <a matTreeNodePadding [matTreeNodePaddingIndent]="10" [href]="catalogHref(node)" (click)="navToCatalog(node, tree, $event)">
                  {{ node.header }}
                  @if (node.productCount > 0) {
                    <span>{{ node.productCount?.toLocaleString() }}</span>
                  }
                </a>

                @if (!node.lastLevel) {
                  <button matTreeNodeToggle>
                    <tui-icon [icon]="tree.isExpanded(node) ? 'chevron-up':'chevron-down'"/>
                  </button>
                  <ul [hidden]="!tree.isExpanded(node)">
                    <ng-container matTreeNodeOutlet />
                  </ul>
                }

              </li>
            </mat-tree-node>
          </mat-tree>
        </div>
      </div>
    </div>
  </div>
</div>
